var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        class: ((_obj = {}), (_obj[_vm.className] = true), _obj),
        attrs: { id: "supsis-badge-unread-count" },
      },
      [
        _vm._v(
          "\n        " + _vm._s(_vm.badge < 1000 ? _vm.badge : "1K+") + "\n    "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }